import type { FeatureManifest } from '../registry.js';
import { mapDue } from './rules.js';

/**
 * SY-03 notifications: per-type preferences (opened from settings, SCR-18) and the soft
 * permission ask after a win or collected offline sales (a prompt: map hook 40, rules.ts).
 */
export default {
  id: 'notifications',
  flag: 'notifications',
  online: true,
  provides: ['notifications', 'notificationsAsk'],
  // a tapped notification (/n/:type: the push's url, from the service worker or the native apps)
  links: ['notification'],
  mapOrder: 40,
  mapDue,
  load: () => import('./index.js'),
} satisfies FeatureManifest;
